core.constant('personalDataTranslationPL', {
  "T": {
    "MODULE": {
      "PERSONAL_DATA": {
        "GENERAL_DATA": "Dane ogólne",
        "REQUIRED_FIELD": "Wymagane pole",
        "INVALID_PESEL": "Nieprawidłowy PESEL",
        "INVALID_DATE": "Nieprawidłowa data",
        "FIRST_NAME": "Imię",
        "LAST_NAME": "Nazwisko",
        "FULL_NAME": "Imię i nazwisko",
        "DOCUMENT_TYPE": "Typ dokumentu",
        "DOCUMENT_NUMBER": "Numer dokumentu",
        "PESEL": "Pesel",
        "CONTACT_DATA": "Dane kontaktowe",
        "FILE_NUMBER": "Numer kartoteki",
        "CITIZENSHIP": "Obywatelstwo kraju",
        "GENDER": "Płeć",
        "EMAIL": "E-mail",
        "MOBILE_PHONE": "Nr tel. komórkowego",
        "EMAIL_SENDING_AGREEMENT": "Zgoda na wysyłkę e-mail",
        "SMS_SENDING_AGREEMENT": "Zgoda na wysyłkę SMS",
        "REGISTER_ADDRESS": "Adres zameldowania",
        "STREET": "Ulica",
        "STREET_NUMBER": "Nr domu",
        "FLAT_NUMBER": "Nr mieszkania",
        "POST_CODE": "Kod pocztowy",
        "CITY": "Miasto",
        "STATE": "Województwo",
        "CORRESPONDENCE_ADDRESS": "Adres korespondencyjny",
        "CORRESPONDENCE_SAME_AS_REGISTER": "Taki sam jak zameldowania",
        "ADD_AUTHORIZED_PERSON": "Dodaj osobę upoważnioną",
        "BIRTH_DATE": "Data urodzenia",
        "INVALID_EMAIL": "Nieprawidłowy adres e-mail",
        "IDENTIFIER": "Identyfikator",
        "REQUIRED_FIELDS_INFORMATION": "Wypełnij wszystkie wymagane pola",
        "DOCUMENTS": "Dokumenty",
        "PATIENT_STATEMENTS": "Oświadczenia pacjenta",
        "AUTHORIZED_PERSONS": "Osoby upoważnione",
        "PREVIEW_AND_EDIT": "Podgląd i edycja",
        "PRINT_TEMPLATE": "Drukuj wzór",
        "PREVIEW_ATTACHMENT": "Podgląd załącznika",
        "AUTHORIZATION_FOR_MEDICAL_FILES_PICK_UP": "Upoważnienie do odbioru dok. med.",
        "PERSONAL_FILES_AND_OTHER_ATTACHMENTS": "Dokumenty osobowe / inne załączniki",
        "GUARDIAN_TYPE": "Typ opiekuna",
        "UPDATE_EWUS_STATUS": "Zaktualizuj status w EWUŚ",
        "EWUS_STATUS": "Zarejestrowany w EWUŚ",
        "NOT_REGISTERED_IN_EWUS": "Niezarejestrowany w EWUŚ",
        "NFZ_OFFICE": "Oddział NFZ",
        "ADDITIONAL_INFORMATIONS": "Informacje dodatkowe",
        "NOTES": "Uwagi",
        "PUBLISH_PATIENT_DATA": "Opublikuj dane pacjenta",
        "WEIGHT_OF_PATIENT_DATA": "Waga danych pacjenta dla symulacji",
        "ACADEMIC_TITLE": "Tytuł akademicki",
        "SPECIALIZATION": "Specjalizacja",
        "COMPANY_NAME": "Nazwa firmy",
        "NIP": "NIP",
        "REGON": "REGON",
        "PERSONAL_DATA": "Dane osobowe",
        "COMPANY_ADDRESS": "Adres firmy",
        "NIP_NUMBER": "NIP pacjenta",
        "COMPANY_NIP": "NIP płatnika",
        "PWZ_NUMBER": "PWZ",
        "SMS_PERMISSION": "Zgoda na SMS",
        "GO_TO_STATE_OF_HEALTH": "Przejdź do ogólnego stanu zdrowia",
        "GO_TO_VISIT_CARD": "Przejdź do karty wizyty",
        "GUARDIANS": "Opiekunowie",
        "GUARDIAN_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć tego opiekuna?",
        "PATIENT_DECLARATION_PERMISSION_INFORMATION": "Do uzyskiwania informacji o stanie mojego zdrowia oraz udzielonych świadczeń zdrowotnych",
        "PATIENT_DECLARATION_MEDICAL_DOCUMENTATION_PERMISSION": "Do uzyskiwania dokumentacji medycznej",
        "AUTHORIZE_NO_ONE": "Nie upoważniam",
        "AUTHORIZE": "Upoważniam",
        "ADD_PERSON": "Dodaj osobę",
        "SAME_PERSON_AS_ABOVE": "Tę samą osobę jak wyżej",
        "SELECT_AUTHORIZED_PERSON_FROM_LIST": "Wybierz osobę upoważnioną z listy",
        "NO_AUTHORIZED_PERSONS": "Brak upoważnionych osób",
        "STATEMENT": "Oświadczenie",
        "TYPE_OF_STATEMENT": "Rodzaj upoważnienia",
        "PATIENT_DID_NOT_AUTHORIZE_NO_ONE": "Pacjent nie upoważnił nikogo",
        "AUTHORIZED_PERSON": "Osoba upoważniona",
        "OPTIONS": "Opcje",
        "GET_STATE_OF_HEALTH_DATA_PERMISSION": "Do uzyskiwania informacji o stanie zdrowia",
        "GET_MEDICAL_DOCUMENTATION_PERMISSION": "Do uzyskiwania dokumentacji medycznej",
        "STATEMENTS": "Oświadczenia",
        "ADD_PERSON": "Dodaj osobę",
        "STATEMENT_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć to oświadczenie?",
        "ADD_GUARDIAN": "Dodaj opiekuna",
        "PATIENT_AUTHORIZED_NO_ONE": "Pacjent nie upoważnił nikogo",
        "STATE_OF_HEALTH": "Stan zdrowia",
        "MEDICAL_DOC": "Dok. medyczna",
        "PRINT": "Drukuj",
        "DELETE": "Usuń",
        "NO_GUARDIANS": "Brak opiekunów",
        "NO_ATTACHMENTS": "Brak załączników",
        "EXPORT_LOG_DISPENSE_ALLOW": "Wydanie kopii dokumentacji",
        "EXPORT_LOG_DISPENSE_DENY": "Odmowa wydania dokumentacji",
        "OFFICE_ADDRESS": "Adres gabinetu",
        "DATE_SCOPE_FROM": "Zakres dat od:",
        "PRINT_SCOPE": "Zakres wydruku",
        "FULL_PATIENT_PROFILE": "Pełny profil pacjenta",
        "PATIENT_STATE_OF_HEALTH": "Ogólny stan zdrowia",
        "VISIT_LIST": "Lista wizyt",
        "PERSONAL_DATA": "Dane osobowe",
        "OFFICE_DATA": "Dane z gabinetu",
        "PATIENT_ATTACHMENTS": "Załączniki pacjenta",
        "DOCUMENTATION_DISPENDED_TO": "Dokumentację wydano:",
        "TO_PATIENT": "Pacjentowi",
        "TO_GUARDIAN_STATE_PARENT": "Opiekunowi/przedstawicielowi ustawowemu",
        "GUARDIAN": "Opiekun",
        "TO_AUTHORIZED_PERSON": "Osobie upoważnionej",
        "TO_AUTHORIZED_ORGANS": "Upoważnionym organom",
        "SHOW_ALL": "Pokaż wykreślone",
        "SHOW_ACTIVE_ONLY": "Pokaż aktywne",
        "DOCUMENTATION_DISPOSAL_DENIAL_LABEL": "Odmowa wydania kopii dokumentacji medycznej",
        "DOCUMENTATION_DISPOSAL_DENIAL_PERSONAL_DATA": "Żądana dokumentacja medyczna nie została wydana Pani/Panu",
        "CROSS_OFF": "Wykreśl"

      }
    },
    "ENUM": {
      "IDENTIFIER_TYPE": {
        "PESEL": "PESEL",
        "MOTHER_PESEL": "PESEL opiekuna prawnego",
        "OTHER": "Inny"
      },
      "IDENTITY_DOCUMENT_TYPE": {
        "ID": "Dowód osobisty",
        "PASSPORT": "Paszport"
      },
      "GENDER": {
        "FEMALE": "Kobieta",
        "MALE": "Mężczyzna"
      },
      "GUARDIAN_TYPE": {
        "PARENT": "Rodzic",
        "LEGAL_GUARDIAN": "Prawny opiekun",
        "ACTUAL_GUARDIAN": "Obecny opiekun",
        "OTHER_THAN_PARENT_STATUORY_GUARDIAN": "Inny niż opiekun ustawowy"
      },
      "RECEIVER_TYPE_TO": {
        "AUTHORIZED_PERSON": "Upoważnionej osobie",
        "GUARDIAN": "Opiekunowi",
        "AUTHORIZED_ORGAN": "Upoważnionemu organowi",
        "PATIENT": "Pacjentowi"
      },
      "GENERATION_STATUS": {
        "IN_PROGRESS": "W trakcie",
        "COMPLETED": "Wydano",
        "FAILED": "Odmowa"
      }
    }
  }
});

